import axios from "axios";
// services
import { auth } from "../services/firebase";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      if (auth?.currentUser) {
        config.headers["Authorization"] = await window.shopify.idToken();
      }

      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalConfig = error.config;

    if (error.response?.status === 401) {
      // re-fetch data if token is steal.
      if (!originalConfig._retry) {
        originalConfig._retry = true;

        return axiosInstance(originalConfig);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
